"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = void 0;
var Permission;
(function (Permission) {
    Permission["NOTEARCHIVE_ADMIN"] = "0FPbMSCvOmNTIOuaKGnh";
    Permission["FEED"] = "UU8Sy0QtXmpdRas9ZwYV";
    Permission["FEED_ADMIN"] = "SW1RPQTYzG01MZjnxRIt";
    Permission["PERSONS"] = "fs78hxEyhacYjKNCBJ6f";
    Permission["CALENDAR"] = "ik7NP2i9DVc4aws7gewP";
    Permission["NOTEARCHIVE"] = "t7Tppue9bSKzpKsDlDqv";
    Permission["PROJECTS"] = "uGblotl3Ppgtk3tgi7rQ";
    Permission["COMMITEEWORK"] = "vD7ZxmIQWR79SK6QOtAo";
    Permission["COMMITEEWORK_SETUP"] = "committeework_setup";
    Permission["SETUP"] = "vRhHdSOQxP97RkeCivjA";
    Permission["BOARDWORK"] = "zw3bgifrOzzpm1MCnWzu";
    Permission["ECONOMY_VISMA"] = "CGz7rmd3w58beKXU5IjT";
    Permission["ECONOMY_FIKEN"] = "sp2ShWuJ5Ls9e5l7uOGQ";
    Permission["ASSETS"] = "permissions_asset";
    Permission["ASSETS_INTRUMENTS"] = "pv4qKisFXNaDkvGcPE1a";
    Permission["ASSETS_UNIFORMS"] = "4u04Nnobj5mDt14LKbbG";
    Permission["WEBSITE"] = "website";
    Permission["WEBSITE_ADMIN"] = "website_admin";
    Permission["RAFFLE"] = "CDUzpevg8euKnzzot3Xo";
    Permission["TICKETSALE"] = "2B1Zz2Yg69aXVmAe81m3";
    Permission["BASIC_PACKAGE_PLUS"] = "6Yu5S2shBk5300IHbgMf";
    Permission["TASKS"] = "MmEx8SnyPypsA3exGgwm";
    Permission["ECONOMY_EXTENSION"] = "tgeuc1Nv5szCSiO6A2k6";
    Permission["PRACTICE_COMPETITION"] = "JVYNXKMAA6yyDcgr1yU4";
    Permission["PERSON_EDIT"] = "NAJfaWouK7U3zAfOvb5S";
})(Permission = exports.Permission || (exports.Permission = {}));
//# sourceMappingURL=permissions.js.map